module.exports = __webpack_public_path__ + "img/hykzsxny.5c76062.png";